module.exports = __webpack_public_path__ + "img/creditcards.effdac01.svg";